import React from 'react';
import { Button, Tooltip } from 'antd';
import { useTranslate } from '@/translations';

interface OperatorProfileActionsProps {
  commsReady: boolean;
  callAvailable: boolean;
  canAllocateJobs: boolean;
  onOpenConversation(): void;
  onStartCall(): void;
  onAllocateJob(): void;
}

export const OperatorProfileActions = ({
  commsReady,
  callAvailable,
  canAllocateJobs,
  onOpenConversation,
  onStartCall,
  onAllocateJob,
}: OperatorProfileActionsProps) => {
  const { t } = useTranslate();
  const actions = [
    {
      icon: <img src="/images/cc-voice.png" alt="Voice Note" />,
      label: t('ccSendVoicenote'),
      disabled: !commsReady,
      onClick: onOpenConversation,
    },
    {
      icon: <img src="/images/cc-call.png" alt="Make Call" />,
      label: t('ccMakeCall'),
      disabled: !callAvailable,
      onClick: onStartCall,
    },
    {
      icon: <img src="/images/cc-message.png" alt="Start Chat" />,
      label: t('ccStartChat'),
      disabled: !commsReady,
      onClick: onOpenConversation,
    },
    ...(canAllocateJobs
      ? [
          {
            icon: <img src="/images/cc-job.png" alt="Allocate Job" />,
            label: t('ccAllocateJob'),
            disabled: false,
            onClick: onAllocateJob,
          },
        ]
      : []),
  ];

  return (
    <div className="d-flex justify-content-around mt-4">
      {actions.map((action) => (
        <div key={action.label} className="text-center">
          <Tooltip title={null}>
            <Button
              className="cc__action-btn"
              shape="circle"
              disabled={action.disabled}
              aria-label={action.label}
              icon={action.icon}
              onClick={action.onClick}
            />
          </Tooltip>
          <div className="small mt-1">{action.label}</div>
        </div>
      ))}
    </div>
  );
};
